import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { connect } from "react-redux"
import Tab from '@material-ui/core/Tab'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'
import 'react-toastify/dist/ReactToastify.css'
import { makeStyles } from '@material-ui/core/styles'
import { CollateralStyles } from '../../CollateralStyles'
import 'react-toastify/dist/ReactToastify.css'
import * as collateralActions from '../../../../actions/collateral/CollateralActions'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../../../actions/common/NavigationActions'
import { useTranslation } from 'react-i18next'
import UseForm from '../../../common/UseForm'
import Modal from 'antd/es/modal';
import TabContext from "@material-ui/lab/TabContext"
import AppBar from "@material-ui/core/AppBar"
import { FormControl, Input } from '@material-ui/core'
import { Typography } from '@material-ui/core'
import Button from "@material-ui/core/Button"
import DataTable from 'react-data-table-component'
import { customStyleSecondary } from '../../../common/CommonStyles'
import Container from '@material-ui/core/Container'
import { Backdrop, CircularProgress } from '@material-ui/core'

const useStyles = makeStyles({
    appbar: {
        backgroundColor: "White"
    },
    tab: {
        backgroundColor: '#A5A5A5',
        '&.Mui-selected': {
            backgroundColor: '#789AC1'
        },
        borderTopRigthRadius: "15%",
        textTransform: "capitalize",
        borderRight: "1px"

    },
    indicator: {
        backgroundColor: "#789AC1"
    },
    buttonSave: {
        backgroundColor: "#003E5E",
        color: "white"
    }
})

const Invoice = ({ classes, ...props }) => {
    const localclass = useStyles();
    const { t } = useTranslation()
    const [valueInternal, setValueInternal] = useState("1");
    const [openBackdrop, setOpenBackdrop] = useState(false);

    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const initialInvoiceBody = {
        "xml": undefined,
        "pdf": undefined,
        "OrderNumber": "",
    }

    const {
        values,
        handleInpuFileChange
    } = UseForm(initialInvoiceBody)

    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fetch_Errors(props.userLanguage, props.userToken, props.match.params.woid, onError, onSuccess)
    }, [valueInternal])// eslint-disable-line react-hooks/exhaustive-deps

    const handleSubmit = e => {
        e.preventDefault()
        if (values.pdf !== undefined && values.xml !== undefined && values.xml.length !== 0 && values.pdf.length !== 0) {
            handleOpenBackdrop()

            const formData = new FormData()
            formData.append('OrderNumber', props.match.params.woid)
            formData.append('BranchOfficeId', props.match.params.branchOfficeId)

            for (let file of values.pdf) {
                formData.append("pdf", file);
            }
            for (let file of values.xml) {
                formData.append("xml", file);
            }

            props.actions.upload_Invoice(props.userLanguage, props.userToken, formData, onError, onSuccessSave)
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onSuccessSave = (response) => {
        handleCloseBackdrop()
        if (response.status) {
            Modal.success({
                title: t('commonMessages.savedSucc')
            })
            Array.from(document.querySelectorAll("input")).forEach(
                input => (input.value = "")
            )
        } else {
            Modal.error({
                title: 'Error',
                content: response.message
            })
        }
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`collateralErrors.${err.response.data.errors.Xml[0]}`)
                    })
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    const checkFileTypePDF = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['application/pdf']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const checkFileTypeXML = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['text/xml', 'application/xml']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const columns = [
        {
            name: t('collateralDetails.invoiceName'),
            selector: 'fileName',
            sortable: true,
            // cell: row => (row.fileName.length > 30 ? `${row.fileName.substring(0, 30)}...` : row.fileName)
            cell: row => row.fileName
        },
        {
            name: t('collateralDetails.evidenceDate'),
            selector: 'evidenceDate',
            sortable: true,
            width: '170px',
            cell: row => row.evidenceDate
        },
        {
            name: t('collateralDetails.errorMessage'),
            selector: 'errorMessage',
            sortable: true,
            cell: row => row.errorMessage
        }
    ]

    const handleChange = (event, newValue) => {
        setValueInternal(newValue);
    };

    return (
        <Container className={classes.generalBorder}>
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <TabContext value={valueInternal}>
                <Grid container direction="row" justify="flex-start" alignItems="center" >
                    <Grid item xs={2}>
                        <AppBar position="static" elevation={0}>
                            <TabList orientation="vertical" onChange={handleChange} className={localclass.appbar} TabIndicatorProps={{ className: localclass.indicator }} >
                                <Tab label={t('collateralDetails.uploadInvoice')} value="1" className={localclass.tab} />
                                <Tab label={t('collateralDetails.errorHistory')} value="2" className={localclass.tab} />
                            </TabList>
                        </AppBar>
                    </Grid>
                    <Grid item xs={10} className={classes.borderLeft}>
                        <TabPanel value="1" >
                            <Grid container >
                                <Grid item xs={1}></Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth >
                                        <br />
                                        <Typography variant="body2">{t('collateralDetails.xmlFile')}</Typography>
                                        <Input
                                            fullWidth
                                            type="file"
                                            name="xml"
                                            onChange={checkFileTypeXML}
                                            className="fileXML"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={5}></Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={1}></Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth >
                                        <br />
                                        <Typography variant="body2">{t('collateralDetails.pdfFile')}</Typography>
                                        <Input
                                            fullWidth
                                            type="file"
                                            name="pdf"
                                            onChange={checkFileTypePDF}
                                            className="filePDF"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={5}></Grid>
                            </Grid>
                            <Grid item xs={12} className={classes.buttonAlign}>
                                <br />
                                <Button type="button" onClick={handleSubmit} className={classes.generalBorder} variant="outlined" >{t('common.upload')}</Button>
                            </Grid>
                        </TabPanel>
                        <TabPanel value="2">
                            <DataTable
                                noHeader
                                columns={columns}
                                customStyles={customStyleSecondary}
                                data={props.invoiceErrors}
                                highlightOnHover
                                defaultSortField="date"
                                dense
                                responsive
                                striped
                                pointerOnHover
                                pagination
                                paginationComponentOptions={paginationOptions}
                                noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                            />
                        </TabPanel>
                    </Grid>
                </Grid>
            </TabContext>
        </Container>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    invoiceErrors: state.CollateralReducer.invoiceErrors,
    result: state.CollateralReducer.result,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(collateralActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(CollateralStyles)(Invoice))
